import React, { useState } from 'react';
import { Tabs, TabsProps, Modal, Image } from 'antd';
import UploadMedia from './upload-media';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import getImage from '../../helpers/getImage';
import ImageGallery from '../image-gallery';
import { t } from 'i18next';

const MediaUpload = ({
  imageList = [],
  setImageList,
  form,
  type,
  multiple = true,
  name,
  disabled,
  text = 'upload',
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const removeImg = (path) => {
    const nextArray = imageList.filter((item) => item !== path);
    form.setFieldsValue({
      images: nextArray,
    });
    setImageList(nextArray);
  };

  const onChange = (key) => {
    console.log(key);
    setTabIndex(key);
  };

  return (
    <>
      <div className='media-upload-wrapper'>
        {imageList
          ?.filter((item) => !item?.isVideo)
          .map((item, idx) => (
            <div
              key={idx}
              className='image-wrapper'
              onClick={() => (disabled ? undefined : removeImg(item))}
            >
              <Image
                preview={false}
                src={getImage(item?.name)}
                className='images'
                alt={'images'}
              />
              <DeleteOutlined color='white' hidden={disabled} />
            </div>
          ))}
        {(multiple || !imageList.length) && (
          <div className='media-upload' onClick={showModal}>
            <PlusOutlined /> <span>{t(text)}</span>
          </div>
        )}
      </div>
      <Modal
        onCancel={handleCancel}
        maskClosable={true}
        visible={isModalOpen}
        footer={false}
        width={'80%'}
      >
        <Tabs
          onChange={onChange}
          items={new Array(2).fill(null).map((_, i) => {
            return {
              label: i == 0 ? `Gallery` : `Upload`,
              key: i,
              children: ''
            };
          })}
        />

        {/* {
          tabIndex == 0 ? (
            <UploadMedia
                form={form}
                setImageList={setImageList}
                imageList={imageList}
                setIsModalOpen={setIsModalOpen}
                name={name}
              />
          ) : ( */}
            <ImageGallery
              type={type}
              disabled={false}
              form={form}
              setFileList={setImageList}
              fileList={imageList}
              setIsModalOpen={setIsModalOpen}
            />
          {/* )
        } */}
      </Modal>
    </>
  );
};
export default MediaUpload;
